import { UserContext } from "utils/context";
import React, { useContext } from 'react';
import fetchData from "utils/fetchData";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [, setUser] = useContext(UserContext);
  const navigate = useNavigate();

  const submit = async e => {
    e.preventDefault();
    const { data, error } = await fetchData({ url: "auth", method: "post", body: new FormData(e.target) });
    if (error) return;
    setUser(data);
    window.localStorage.setItem("user", JSON.stringify(data));
    navigate("/");
  }

  return <div className="page">
    <main>
        <form onSubmit={submit} className="card main">

          <h1 className="gradient">Connexion</h1>

          <input type="text" placeholder="Email" name="email" />

          <input placeholder="Mot de passe" name="password" type="password" />

          <label className="switch">
            <input className="switch__input" type="checkbox" />
            <i className="switch__icon"></i>
            <span className="switch__span">Se souvenir de moi</span>
          </label>

          <button type="submit">Se connecter</button>

        </form>
    </main>
  </div>
}

export default Login;